import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const MeetingsCopyLinkIcon: React.FC<IconProps> = (props) => (
  <Icon
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="7"
      y="7"
      width="12"
      height="12"
      rx="3"
      stroke="currentColor"
      strokeWidth="1.75"
    />
    <path
      d="M15 5.75C15 4.50736 13.9926 3.5 12.75 3.5H7.25C5.45507 3.5 4 4.95507 4 6.75V12.25C4 13.4926 5.00736 14.5 6.25 14.5"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </Icon>
);
